import { Component, OnInit,Inject } from '@angular/core';
import {MatDialog, MatDialogRef,MAT_DIALOG_DATA} from '@angular/material';
import { JarwisService } from 'src/app/Services/jarwis.service';
import { DataUserService } from 'src/app/Services/data-user.service';
import { DataApiService } from 'src/app/Services/data-api.service';
import { AlertComponent } from '../alert/alert.component';

export interface DialogData {
  nombre_comercial: string;
  razon_social : string;  
}

@Component({
  selector: 'app-dialog-crear-cuenta-secundaria',
  templateUrl: './dialog-crear-cuenta-secundaria.component.html',
  styleUrls: ['./dialog-crear-cuenta-secundaria.component.scss']
})
export class DialogCrearCuentaSecundariaComponent implements OnInit {

  constructor(
    private dialog: MatDialog,
    private Jarwis:JarwisService,
    private DataUser:DataUserService,
    private dataApi:DataApiService,
    public dialogRef: MatDialogRef<DialogCrearCuentaSecundariaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData 
  ) { }

  public form={
    id_root:this.DataUser.dataUser(this.dataApi.tokenUser(localStorage.getItem("token"))),
    nombre_comercial:this.data.nombre_comercial,
    razon_social:this.data.razon_social,
    name:null,
    surname:null,
    email:null,
    telefono1:null,
    telefono2:null,
    password:null,
    password_confirmation:null,
    area:null,
    convenio: (localStorage.getItem("convenio")=="activado") ? 1: 0
  }

  ngOnInit() {  
    
  }

  public mensaje ="La cuenta secundaria se ha creado con éxito";
  public error = [];

  onSubmit(){
    this.Jarwis.cuentaSecundaria(this.form).subscribe(
      data=>this.handleResponse(data),
      error =>this.handleError(error)
    )
  }

  handleResponse(data){
    this.dialog.closeAll();
      const dialogRef = this.dialog.open(AlertComponent,{
        width:"200px",
        data:{mensaje:this.mensaje},
        disableClose: false,
        autoFocus:true
      }); 
  
      dialogRef.afterClosed().subscribe(result => {      
        this.mensaje = result;
      });
  }
  handleError(error){
    this.error = error.error.errors;
  }

  CerrarModal(){
    this.dialog.closeAll();
  }
  

  visibility(visibility,visibilityIcon){ 
    const mostrar_password = document.querySelector(visibility);
    const type = mostrar_password.getAttribute("type");
    const visibility_icon = <HTMLElement>document.querySelector(visibilityIcon);
    if(type == "password"){
      mostrar_password.setAttribute("type","text");
      visibility_icon.classList.add('visibility_icon_active');
    }else{
      mostrar_password.setAttribute("type","password");
      visibility_icon.classList.remove('visibility_icon_active');
    }
  }

}
